import { BibliographyClass } from '@/types'
import { FirstMarcLabel, FirstMarcLabelFromJSON, SystemCode } from '@/api'
import * as runtime from '../runtime'

export class MarcLabelApi extends runtime.BaseAPI {
  async getAll(
    bibliographyClass: BibliographyClass,
    searchType: SystemCode,
    isEdit: boolean
  ): Promise<FirstMarcLabel[]> {
    const response = await this.requestGet('/marc-labels', {
      bibliography_class: bibliographyClass,
      search_type: searchType.code,
      is_edit: isEdit
    })

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(FirstMarcLabelFromJSON)
    ).value()
  }
}
